import React, { useEffect, useState } from "react";
import "../Assets/Css/Table.scss";
import TableRow from "./TableRow";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { customStyle } from "./Style";
import Select from "react-select";
import queryString from "query-string";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const options = [
  { value: 5, label: 5 },
  { value: 10, label: 10 },
  { value: 15, label: 15 },
  { value: 20, label: 20 },
];

const Table = (props) => {
  const header = props.header;
  const data = props.data;
  const footer = props.footer;
  const count = props.count;
  const records = props.records;
  const totalSelectedIds = props.totalSelectedIds;
  const [modelData, setModelData] = useState({});
  const [show, setShow] = useState(false);
  const checked = props.checked;
  const selectedId = props.selectedId;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();
  const location = useLocation();
  const showIsView = props.showIsView;
  const idsArray = data.map((row) => {
    return row?.invoiceId?.value;
  });
  const [selectedOption, setSelectedOption] = useState(options[3]);

  const totalPages = Math.ceil(records / limit);
  const startIndex = (page - 1) * limit;
  const endIndex = page==1 ? Math.min(startIndex + limit, count) : startIndex + count

  const handleClose = () => {
    setShow(false);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit.value);
    setSelectedOption(newLimit);
    setPage(1);
  };

  useEffect(() => {
    if (footer === true) {
      let otherParams = queryString.parse(location.search);
      let params = { ...otherParams };
      params.limit = limit;
      params.page = page;

      const stringParams = queryString.stringify(params);
      navigate(`?${stringParams}`);
    }
  }, [page, limit]);

  return (
    props.loading ? 
      <div style={{
        display:"flex",
        justifyContent:"center",
        width : "100%"
      }}>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
      </div>
       : 
    <div className="table-main">
      <table className="table-container">
        <thead className="table-head">
          <tr className="table-header-row">
            {header.map((col, index) => {
              if (col.field === "Sr No") {
                return (
                  <th className="table-header-th" key={index}>
                    #
                  </th>
                );
              } else if (col.field === "checkbox") {
                return (
                  <th className="table-header-th" key={index}>
                    <input
                      type="checkbox"
                      id={`headerAll`}
                      checked={
                        idsArray.length === totalSelectedIds.length
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        let event = [e.target.checked, e.target.id, idsArray];
                        props.handleChange(event);
                      }}
                    />
                  </th>
                );
              }

              return <th className="table-header-th">{col.field}</th>;
            })}
          </tr>
        </thead>

            <tbody className="table-body">
            {data.length > 0 ? 
            (data?.map((row, index) => (
                <TableRow
                 key={index}
                 setShow={setShow}
                 setModelData={setModelData}
                 data={row}
                 index={index}
                 header={header}
                 checked={checked}
                 selectedId={selectedId}
                 totalSelectedIds={totalSelectedIds}
                 handleChange={props.handleChange}
                 idsArray={idsArray}
                 showIsView={showIsView}
               />
             ))) : 
             <tr>
              <td colSpan={header.length.toString()} style={{
               textAlign : "center",
               padding: "10px 0"
              }}>No Records</td>
             </tr> }
             </tbody> 
      </table>
      {footer ? (
        <div className="table-footer">
          <div className="footer-container">
            <div className="foot-left-part"></div>
            <p className="text-footer">Rows per Pages:</p>
            <div className="selection-part">
              <Select
                defaultValue={selectedOption}
                onChange={handleLimitChange}
                options={options}
                placeholder={"Client"}
                styles={customStyle}
                menuPlacement="top"
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
              />
            </div>
            <p className="showRowCount">
              {" "}
              {startIndex}-{endIndex} of {totalPages}
            </p>
            <div className="buttonCollection">
              <button
                className="buttonAll"
                onClick={() => {
                  if (page === 1) {
                    handlePageChange(page);
                  } else {
                    handlePageChange(page - 1);
                  }
                }}
              >
                <AiOutlineLeft />
              </button>

              {page < totalPages ? <button
                className="buttonAll"
                onClick={() => {
                  handlePageChange(page + 1);
                }}
              >
                <AiOutlineRight />
              </button> : <button
                className="buttonAll"
                disabled
              >
                <AiOutlineRight />
              </button>}
              
            </div>
          </div>
        </div>
      ) : null}
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            View full details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid details-model">
          <Container>
            <Row>
              <Col lg={6} md={6}>
                Name: <br />
                {modelData.name}
              </Col>
              <Col lg={6} md={6}>
                Email: <br />
                {modelData.email}
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={6} md={6}>
                Phone Number: <br />
                {modelData.phoneNumber}
              </Col>
              <Col lg={6} md={6}>
                Subject: <br />
                {modelData.subject}
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12} md={12}>
                Description: <br />
                {modelData.description}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Table;
